<section>
   @if (currentInterval()) {
      <shared-ui-date-input
         [disabledDates]="disabledReportDays"
         [inputFormControl]="fg.controls.reportDate"
         [label]="'intermediate_report.report_date' | translate"
         [max]="reportDateMax"
         [min]="reportDateMin"
         matTooltip="{{ fg.controls.reportDate.disabled ? ('intermediate_report.control_disabled' | translate) : '' }}"
      ></shared-ui-date-input>
   }

   <shared-ui-dropdown-input
      [clearButton]="false"
      [data]="intervalFormData"
      [inputFormControl]="fg.controls.interval"
      [label]="'intermediate_report.intermediate_report_interval_frequency' | translate"
      class="mb-4"
      matTooltip="{{ fg.controls.interval.disabled ? ('intermediate_report.control_disabled' | translate) : '' }}"
      textField="label"
      valueField="value"
   ></shared-ui-dropdown-input>

   @if (loadingDates()) {
      <div class="flex justify-center my-6">
         <mat-spinner [diameter]="32"></mat-spinner>
      </div>
   } @else {
      <div
         [class.mb-8]="fg.controls.reports.controls.length > 0"
         class="grid grid-cols-[2fr_4fr_max-content] gap-4 items-center"
      >
         @for (control of fg.controls.reports.controls; track control.value; let i = $index) {
            <p>{{ 'intermediate_report.report' | translate }} {{ i + 1 }}</p>

            <div class="flex items-center">
               <div
                  [class.bg-tertiary]="control.controls.date.dirty || control.controls._metadata.value?.is_manual_set"
                  class="w-2 h-2 rounded-full mr-2"
               ></div>
               <shared-ui-date-input
                  [disabledDates]="disabledReportDays"
                  [inputFormControl]="control.controls.date"
                  [max]="reportDateMax"
                  [min]="reportDateMin"
                  [placeholder]="'DD-MM-YYYY'"
                  class="w-full"
                  matTooltip="{{
                     control.controls.date.disabled
                        ? ((control.controls.date.value <= today ? 'intermediate_report.report_date_past' : 'intermediate_report.control_disabled') | translate)
                        : ''
                  }}"
               ></shared-ui-date-input>
            </div>

            <button
               (click)="removeReportDate(i)"
               [disabled]="control.controls.date.disabled"
               mat-icon-button
            >
               <fa-icon [icon]="['fas', 'circle-xmark']"></fa-icon>
            </button>
         }
      </div>

      @if (canAddDate()) {
         <button
            (click)="addReportDate()"
            class="w-full flex items-center"
            mat-stroked-button
         >
            <fa-icon [icon]="['far', 'add']"></fa-icon>
            {{ 'intermediate_report.add_report' | translate }}
         </button>
      }
   }
</section>
